<template>
    <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card body-style="padding: 30px">
                <img class="img" src="../../../assets/img/cp/dzp.jpg" alt="">
                <div class="introduce">
                    <p class="inner_title">工业电阻屏</p>
                    <p class="s-detail">
                        显示、触控、PC系统一体化超薄设计；
                        一体成形，ABS材料，美观大方，媲美苹果MAC；
                        最新的投射式电容屏技术，支持10点触摸，支持手写及多点手势；
                        响应速度快达5MS，无干扰，书写和演示流畅度高；
                        抗光干扰，确保操作的准确性（强光直射照常使用）；
                        安全性外观设计，四角圆滑，表面无尖锐边缘，升级更为人性化；<a href="#">[详情]</a>
                    </p>
                    <p class="end_title">钧飞智能科技有限公司出品</p>
                </div>
            </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-card body-style="padding: 30px">
                <img class="img" src="../../../assets/img/cp/drp.jpg" alt="">
                <div class="introduce">
                    <p class="inner_title">工业电容屏</p>
                    <p class="s-detail">
                        该领域的终端产品应用环境相对比较好，主要在室内应用，
                        对电容屏的要求相对比较低（带伺服电机的智能产品除外），
                        主要关注灵敏度，抗干扰性及成本，如智能家电，智能安防等，
                        所以一般推荐G+F（F）结构，少量定位偏高端的产品也会选用G+G结构；
                        <a href="#">[详情]</a>
                    </p>
                    <p class="end_title">钧飞智能科技有限公司出品</p>
                </div>
            </el-card>

        </el-col>
    </el-row>
</template>

<script>
  export default {}
</script>

<style src="../../../assets/css/smartModule.css" scoped>
    /*@import "../../assets/css/smartModule.css";*/
</style>
